<template>
  <div id="app" ref="container" style="overflow-y: auto">
    <router-view />
  </div>
</template>
<script>

export default {
  name: 'App',
  watch: {
    '$route'() {
      // 当路由变化时执行的操作
      this.scrollToBottom()
    }
  },
  mounted() {
    this.scrollToBottom()
  },
  methods:{
    scrollToBottom() {
      this.$nextTick(() => {
        console.log('this.$refs.container',this.$refs.container.scrollTop)
        if (this.$refs.container) {
          this.$refs.container.scrollTop = 0;
        }
      });

    },
  }
}
</script>
<style lang="css" src="./assets/common.css">
</style>
<style>
  p{
    line-height: 35px!important;
  }
</style>
